// ------------------------------------
// Constants
// ------------------------------------
export const initialState: State.StaticLandingPagesContent = {
  staticLandingPage: [],
  staticLandingPageFetched: false,
  skipStaticLandingPageFrontloadRequest: false,
};
